<template>
  <action-dispatcher action="user/get">
    <h1 class="page-title">Meu perfil</h1>
    <form
      @submit.prevent="submit"
      class="edit-profile-information mt-9 mt-lg-0"
    >
      <h5>Perfil público</h5>
      <h6 class="font-weight-normal text-secondary">
        Estes dados aparecerão para qualquer pessoa quando acessar o seu perfil
        ou as suas páginas de produto.
      </h6>
      <div class="row">
        <div class="col-lg-9">
          <div class="row mt-6">
            <div class="col-lg-4 pt-3">
              <input-image
                v-model="form.picture"
                title="Selecionar foto"
                description="Use uma imagem no formato JPG ou PNG com no máximo 5MB de tamanho. Dimensões recomendadas: 800x800px."
              />
            </div>
            <div class="col-lg-8 pl-lg-6">
              <h6>Sobre você</h6>
              <form-group
                v-model="form.name"
                id="name"
                label="Seu nome ou nome fantasia da empresa"
                placeholder="Prefira um nome que chame atenção do público"
                :errors="errors.name"
              />

              <form-group
                class="mt-6"
                v-model="form.website"
                id="website"
                label="Website"
                placeholder="ex: josesilva.com.br"
                :errors="errors.website"
                rows="5"
              />

              <form-group
                class="mt-6"
                v-model="form.description"
                id="description"
                label="Descrição"
                placeholder="Fale um pouco sobre você"
                textarea
                :errors="errors.description"
                rows="5"
              />
              <div class="form-group">
                <b-form-checkbox v-model="form.show_numbers">
                  Exibir meus números da área de membros Blitzpay
                </b-form-checkbox>
              </div>

              <hr class="mb-9" />

              <h6>Redes sociais</h6>
              <div class="d-flex align-items-center">
                <div class="icon-social-media">
                  <i class="icon-facebook" />
                </div>
                <form-group
                  class="flex-fill"
                  v-model="form.facebook_url"
                  id="facebook_url"
                  placeholder="facebook.com/sua-pagina"
                  :errors="errors.facebook_url"
                  rows="5"
                />
              </div>

              <div class="d-flex align-items-center">
                <div class="icon-social-media">
                  <i class="icon-instagram" />
                </div>
                <form-group
                  class="flex-fill"
                  v-model="form.instagram_url"
                  id="instagram_url"
                  placeholder="instagram.com/seu-perfil"
                  :errors="errors.instagram_url"
                  rows="5"
                />
              </div>

              <div class="d-flex align-items-center">
                <div class="icon-social-media">
                  <i class="icon-youtube" />
                </div>
                <form-group
                  class="flex-fill"
                  v-model="form.youtube_url"
                  id="youtube_url"
                  placeholder="youtu.be/id-youtube"
                  :errors="errors.youtube_url"
                  rows="5"
                />
              </div>

              <div class="d-flex align-items-center">
                <div class="icon-social-media">
                  <i class="icon-twitter" />
                </div>
                <form-group
                  class="flex-fill"
                  v-model="form.twitter_url"
                  id="twitter_url"
                  placeholder="twitter.com/sua-perfil"
                  :errors="errors.twitter_url"
                  rows="5"
                />
              </div>

              <hr class="mb-9" />

              <h6>Termos de uso</h6>
              <div class="form-group">
                <b-form-checkbox v-model="form.accept_terms">
                  Declaro que li e concordo os
                  <a
                    href="https://pay.blitzpay.com.br/termos-de-uso"
                    target="_blank"
                    >Termos de Uso</a
                  >
                  da Blitzpay.
                </b-form-checkbox>
              </div>
              <div class="row mt-9">
                <div class="col-lg-6 mb-3 mb-lg-0">
                  <router-link
                    class="btn btn-fixed-size btn-outline-secondary btn-block"
                    :to="{ name: '/' }"
                  >
                    Cancelar
                  </router-link>
                </div>
                <div class="col-lg-6">
                  <button
                    type="submit"
                    class="btn btn-fixed-size btn-block"
                    :class="isValid ? 'btn-primary ' : 'btn-secondary'"
                    :disabled="!isValid"
                  >
                    <loading :show="loading">
                      Salvar
                    </loading>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </action-dispatcher>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  data() {
    return {
      ...formFields(
        [
          "name",
          "description",
          "picture",
          "show_numbers",
          "facebook_url",
          "instagram_url",
          "youtube_url",
          "twitter_url",
          "accept_terms"
        ],
        {
          show_numbers: false,
          accept_terms: false,
          name: this.$user.user.name,
          picture: this.$user.user.picture
        }
      ),
      fileInfo:
        !this.$user.user || !this.$user.user.picture
          ? null
          : {
              src: this.$user.user.picture,
              name: ""
            },
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photo",
      loading: false
    };
  },
  computed: {
    isValid() {
      let valid = false;
      for (const key in this.form) {
        valid = Array.isArray(this.form[key])
          ? this.form[key].length
          : !!this.form[key];
      }
      return valid;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store
        .dispatch("user/update", this.form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeImage() {
      document.getElementById("file-img").click();
    },
    resetImage() {
      this.fileInfo = null;
      this.form.picture = null;
      document.getElementById("file-img").type = "text";
      document.getElementById("file-img").type = "file";
    },
    fileChange(files) {
      if (!files) return;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(Math.floor(Math.log(files[0].size) / Math.log(1024)));
      const size =
        Math.round(files[0].size / Math.pow(1024, i), 2) + " " + sizes[i]; // convert to mb and show unit meansurement

      if (size.match("MB") && /([^MB]*)MB/.exec(size)[1] > 5) {
        this.$message.error("O arquivo deve ter no máximo 5 mb");
        return;
      }

      this.getImage(files[0]).then(img => {
        this.form.picture = img;
        this.fileInfo = {
          name: files[0].name,
          src: img
        };
      });
    },
    getImage(file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader();
        const img = document.createElement("img");

        fReader.onload = () => {
          img.src = fReader.result;
          resolve(this.getBase64Image(img));
        };

        fReader.readAsDataURL(file);
      });
    },
    getBase64Image(img) {
      const dataURL = img.src;
      return dataURL;
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-profile-information {
  .icon-social-media {
    padding: 15px;
    i {
      font-size: 28px;
    }
  }

  label {
    font-weight: 400;
    color: #595463;
    font-size: 14px;
  }
}
</style>
